import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "spacer" }, "-", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(_component_el_form_item, {
    label: _ctx.field.label,
    prop: _ctx.field.prop,
    rules: _ctx.field.rule,
    class: "FormSalary",
    ref: "formItemElement"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_input, {
        modelValue: _ctx.innerMinValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerMinValue) = $event)),
        placeholder: "最小值",
        disabled: _ctx.innerIsNegotiable === 1 || _ctx.field.disabled
      }, null, 8, ["modelValue", "disabled"]),
      _hoisted_1,
      _createVNode(_component_el_input, {
        modelValue: _ctx.innerMaxValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.innerMaxValue) = $event)),
        placeholder: "最大值",
        disabled: _ctx.innerIsNegotiable === 1 || _ctx.field.disabled
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode(_component_el_checkbox, {
        "true-label": 1,
        "false-label": 0,
        modelValue: _ctx.innerIsNegotiable,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.innerIsNegotiable) = $event)),
        disabled: _ctx.field.disabled
      }, {
        default: _withCtx(() => [
          _createTextVNode("面议")
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]),
    _: 1
  }, 8, ["label", "prop", "rules"]))
}